import { html, ref, repeat } from '@genesislcap/web-core';
import type { CombinedRatings } from './combined-ratings';

export const CombinedRatingsTemplate = html<CombinedRatings>`
  <div class="ag-set-filter">
    <div role="presentation" class="ag-input-text-field ag-mini-filter ag-input-field">
      <div class="ag-wrapper ag-input-wrapper ag-input-text-field-input-wrapper" role="presentation">
        <input
          class="ag-input-field-input ag-input-text-field-input"
          type="text"
          placeholder="${(x) => x.searchPlaceholder}"
          :value="${(x) => x.searchText}"
          @input="${(x, c) => x.handleSearchInput(c.event)}"
        />
      </div>
    </div>

    <div class="ag-set-filter-list" role="presentation">
      <div class="ag-list-item">
        <div class="ag-set-filter-item">
          <div
            role="presentation"
            class="ag-checkbox ag-set-filter-item-checkbox ag-input-field ag-labeled ag-label-align-right"
          >
            <div
              class="ag-input-field-label ag-checkbox-label ag-label ag-label-ellipsis"
              @click="${(x) => x.handleSelectAllLabelClick()}"
            >
              (Select All)
            </div>
            <div class="${(x) => x.selectAllWrapperClass}" role="presentation">
              <input
                ${ref('selectAllInput')}
                class="ag-input-field-input ag-checkbox-input"
                type="checkbox"
                tabindex="-1"
                ?checked="${(x) => x.selectAllState.checked}"
                @change="${(x, c) => x.handleSelectAllChange(c.event)}"
              />
            </div>
          </div>
        </div>
      </div>

      ${repeat(
        (x) => x.visibleOptions,
        html<string, CombinedRatings>`
          <div class="ag-list-item">
            <div class="ag-set-filter-item">
              <div
                role="presentation"
                class="ag-checkbox ag-set-filter-item-checkbox ag-input-field ag-labeled ag-label-align-right"
              >
                <div
                  class="ag-input-field-label ag-checkbox-label ag-label ag-label-ellipsis"
                  @click="${(option, c) => c.parent.handleOptionLabelClick(option)}"
                >
                  ${(option, c) => c.parent.formatOptionLabel(option)}
                </div>
                <div class="${(option, c) => c.parent.getOptionWrapperClass(option)}" role="presentation">
                  <input
                    class="ag-input-field-input ag-checkbox-input"
                    type="checkbox"
                    tabindex="-1"
                    ?checked="${(option, c) => c.parent.selectedValues.includes(option)}"
                    @change="${(option, c) => c.parent.handleOptionChange(c.event, option)}"
                  />
                </div>
              </div>
            </div>
          </div>
        `,
      )}
    </div>
  </div>
`;
